import React, { PureComponent } from "react";
import { connect } from "react-redux";
import LocalOfferOutlinedIcon from "@material-ui/icons/LocalOfferOutlined";
import instance from "../../../store/actions/instance";
import { Apply_Promo } from "../../../store/actions";
import TextField from "@material-ui/core/TextField";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ReactComponent as Error } from "../../CheckoutProcess/assets/close.svg";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import PromotionActionButton from "../../Promotions/PromotionActionButton";
import { getCurrencyIso } from "../../../Helpers/currencyConverter";

const PromoAPI = (code, branch, currency, channel) =>
  instance.post("coupon/", {
    code: code,
    branch: branch,
    country_code: currency,
    channel: channel,
  });
const PromoAPIDebounced = AwesomeDebouncePromise(PromoAPI, 1000);
class AppliedCoupons extends PureComponent {
  state = {
    loading: false,
    failed: false,
    expiredMessage: "",
    expiredMessageAR: "",
  };
  handleTextChange = async (code) => {
    this.setState({ loading: true, failed: false });
    try {
      let store_branch_id = null;
      if (this.props.branch) {
        store_branch_id = this.props.branch.branch;
      }
      const result = await PromoAPIDebounced(
        code,
        store_branch_id,
        this.props.currency.selected,
        this.props.channel
      );

      this.props.Apply_Promo(result.data);
      this.setState({ loading: false });
    } catch (err) {
      const isExpired = err?.response?.data?.error === "expired";

      if (isExpired) {
        this.setState({
          loading: false,
          failed: true,
          expiredMessage: err.response.data.expired_message,
          expiredMessageAR: err.response.data.expired_message_ar,
        });
      } else {
        this.setState({
          loading: false,
          failed: true,
          expiredMessage: "",
          expiredMessageAR: "",
        });
      }
    }
  };

  render() {
    const { language, settings } = this.props;
    const promo = this.props.promo;
    const currencyIso = getCurrencyIso(settings,language)

    const promoSubtitleRender = () => {
      if (promo.discount_type == "delivery") {
        return "Free delivery";
      } else if (promo.discount_type == "percent") {
        return `${parseInt(promo.discount_amount)}% off`;
      } else if (promo.discount_type == "fixed") {
        return `${promo.discount_amount.toFixed(settings.currency_decimals)} ${
          currencyIso
        } off`;
      }
    };

    const promoSubtitleRenderArabic = () => {
      if (promo.discount_type == "delivery") {
        return "توصيل مجاني";
      } else if (promo.discount_type == "percent") {
        return `خصم ${promo.discount_amount}%`;
      } else if (promo.discount_type == "fixed") {
        return `خصم ${promo.discount_amount.toFixed(
          settings.currency_decimals
        )} ${
          currencyIso
        }`;
      }
    };

    return (
      <div style={{ marginTop: 30 }}>
        <p
          className="box-title"
          style={{ textAlign: language === "arabic" ? "right" : "left" }}
        >
          {language == "english" ? "Promotions" : "العروض"}
        </p>

        {promo ? (
          <div
            className="bordered"
            style={{
              display: "grid",
              gridTemplateColumns: "50px auto 50px",
              alignItems: "center",
              background: "white",
              minHeight: promo.isSmartPromo ? 100 : 80,
              paddingBottom: promo.isSmartPromo && 6,
              direction: language === "arabic" ? "rtl" : "ltr",
            }}
          >
            <div>
              <LocalOfferOutlinedIcon
                style={{
                  color: "#5b5b5b",
                }}
              />
            </div>
            <div className={language === "arabic" ? "text-right" : "text-left"}>
              {promo.code ? (
                <p className="mb-1 bold">
                  {language == "english" ? "Code:" : "الرمز:"} {promo.code}
                </p>
              ) : (
                <p className="mb-1 bold">
                  {language == "english"
                    ? promo?.promo?.name
                    : promo?.promo?.ar_name}
                </p>
              )}
              <p
                style={{
                  color: "#737373",
                  display: "block",
                  paddingLeft: language == "english" && 24,
                  paddingRight: language == "arabic" && 24,
                  marginBottom: 0,
                }}
                dir={language == "english" ? "ltr" : "rtl"}
              >
                {language == "english"
                  ? promoSubtitleRender()
                  : promoSubtitleRenderArabic()}
              </p>
              <div style={{ marginTop: 5 }}>
                {promo.isSmartPromo && (
                  <PromotionActionButton
                    fromCart
                    promo={promo.promo}
                    isCoupon={!promo.isSmartPromo}
                    returnURL={"/checkout/confirmation"}
                  />
                )}
              </div>
            </div>

            <div>
              <DeleteForeverIcon
                onClick={() => this.props.Apply_Promo()}
                width={25}
                height={25}
                style={{
                  cursor: "pointer",
                  color: "#ff4242",
                }}
              />
            </div>
          </div>
        ) : (
          <div
            className="bordered"
            style={{
              display: "grid",
              gridTemplateColumns: "50px auto 50px",
              alignItems: "center",
              background: "white",
              height: "100%",
              minHeight: 80,
              paddingBlock: 8,
              alignItems: "center",
              direction: language === "arabic" ? "rtl" : "ltr",
            }}
          >
            <div style={{ height: "40%", alignContent: "flex-start" }}>
              <LocalOfferOutlinedIcon style={{ color: "#5b5b5b" }} />
            </div>
            <div style={{ alignSelf: "flex-start" }}>
              <TextField
                fullWidth
                onChange={(e) => this.handleTextChange(e.target.value)}
                color="red"
                style={{
                  width: "100%",
                  position: "relative",

                  left: 0,
                  textAlign: language === "arabic" ? "right" : "left",
                }}
                defaultValue={this.props.specialRemarks}
                InputLabelProps={{
                  style: {
                    transformOrigin:
                      language == "english" ? "top left" : "top right",
                    right: language == "arabic" ? 0 : "unset",
                    left: language == "english" ? 0 : "unset",
                  },
                  dir: language == "english" ? "ltr" : "rtl",
                }}
                InputProps={{
                  dir: language == "english" ? "ltr" : "rtl",
                  paddingBottom: 10,
                }}
                label={
                  language === "arabic"
                    ? "ادخل رمز الكوبون"
                    : "Enter promotion code"
                }
              />
              {this.state.failed &&
                ((language === "english" && this.state.expiredMessage) ||
                  (this.state.expiredMessageAR && language === "arabic")) && (
                  <div
                    style={{
                      color: "red",
                      fontSize: 12,
                      float: "inline-start",
                    }}
                  >
                    {language === "arabic"
                      ? this.state.expiredMessageAR
                      : this.state.expiredMessage}
                  </div>
                )}
            </div>

            {(this.state.loading || this.state.failed) && (
              <div>
                {this.state.loading && (
                  <CircularProgress style={{ width: 20, height: 20 }} />
                )}
                {this.state.failed && <Error width={18} height={18} />}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    settings: state.store.store.settings,
    language: state.store.language,
    promo: state.cart.promos,
    branch: state.branch,
    currency: state.currency,
    channel: state.promise.src,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    Apply_Promo: (promo) => dispatch(Apply_Promo(promo)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppliedCoupons);
